<template>
  <div class="inventory-container p-4">
    <!-- Inventory Items -->
    <div v-if="inventoryItems.length > 0" class="mb-8">
      <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
        <div v-for="item in inventoryItems" :key="item.id" 
             class="flex flex-col items-center p-4 bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow">
          <div class="relative mb-3">
            <img :src="item.image.preview_url" 
                 :alt="item.name"
                 class="w-16 h-16 object-contain" />
            <div v-if="item.quantity > 1" 
                 class="absolute -top-2 -right-2 bg-blue-500 text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center">
              {{ item.quantity }}
            </div>
          </div>
          <div class="text-center">
            <div class="text-sm font-medium text-gray-900">{{ item.name }}</div>
            <div v-if="item.description" class="text-xs text-gray-600 mt-1">{{ item.description }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div v-else class="text-center py-12">
      <p class="text-gray-600 mt-8">{{ inventoryEmptyDescription }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moduleManager from '../modules/index.js'
import { showMultiLingualText } from '../utils/languageUtils.js'

export default {
  name: 'Inventory',
  data() {
    return {
      inventory: {}
    }
  },
  computed: {
    ...mapGetters('settings', ['tourSettings']),
    
    inventoryItems() {
      if (!this.inventory) return []
      
      return Object.values(this.inventory).map(item => ({
        id: item.object?.id || item.id,
        name: item.object?.name || item.name,
        description: item.object?.description || item.description,
        image: item.object?.image || item.image,
        quantity: item.quantity || 1
      }))
    },
    
    // Multilingual text support
    inventoryTitle() {
      return showMultiLingualText(
        this.tourSettings?.game?.inventory_title,
        this.$t('game.inventory'),
        false,
        this.$i18n.locale?.substring(0, 2)
      )
    },
    
    inventoryEmptyDescription() {
      return showMultiLingualText(
        this.tourSettings?.game?.inventory_empty_description,
        this.$t('game.inventory_empty_description'),
        false,
        this.$i18n.locale?.substring(0, 2)
      )
    }
  },
  mounted() {
    this.loadInventory()
    
    // Listen for inventory updates
    moduleManager.addEventListener('game:inventory_updated', this.loadInventory.bind(this))
  },
  methods: {
    loadInventory() {
      // Get inventory from game module
      const gameState = moduleManager.getModuleData('game')
      if (gameState?.inventory) {
        this.inventory = gameState.inventory
      }
    }
  },
  beforeUnmount() {
    // Clean up event listeners
    moduleManager.removeEventListener('game:inventory_updated', this.loadInventory.bind(this))
  }
}
</script> 